import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import FilterToggle from "../../../../atoms/FilterToggle";

const FilterQYR = ({ filters, setFilters }) => {
    const handleChange = (e) => {
        setFilters(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setFilters(prev => ({
            ...prev,
            status: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleIncidentRangeChange = (dates) => {
        const [start, end] = dates;
        setFilters(prev => ({
            ...prev,
            incidentRange: { start, end }
        }));
    };

    const handleServiceRangeChange = (dates) => {
        const [start, end] = dates;
        setFilters(prev => ({
            ...prev,
            serviceRange: { start, end }
        }));
    };

    const handleReset = () => {
        setFilters({
            description: "",
            incidentRange: { start: null, end: null },
            serviceRange: { start: null, end: null },
            status: "",
        });
    };

    const statusOptions = [
        { value: "", label: "Todos" },
        { value: "Pendiente", label: "Pendiente" },
        { value: "Resuelto", label: "Resuelto" },
    ];

    const selectedStatus = statusOptions.find(option => option.value === filters.status);

    return (
        <FilterToggle>
            <div className="w-full flex flex-col gap-2">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <input
                        type="text"
                        placeholder="Buscar por queja o reporte"
                        name="description"
                        value={filters.description}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    <Select
                        name="status"
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={handleStatusChange}
                        className="w-full"
                        classNamePrefix="react-select"
                        isClearable
                    />
                    <div className="w-full">
                        <DatePicker
                            selectsRange
                            startDate={filters.incidentRange.start}
                            endDate={filters.incidentRange.end}
                            onChange={handleIncidentRangeChange}
                            placeholderText="Rango de Reporte"
                            className="border p-2 rounded w-full min-w-0"
                            isClearable
                        />
                    </div>
                    <div className="w-full">
                        <DatePicker
                            selectsRange
                            startDate={filters.serviceRange.start}
                            endDate={filters.serviceRange.end}
                            onChange={handleServiceRangeChange}
                            placeholderText="Rango de Servicio"
                            className="border p-2 rounded w-full min-w-0"
                            isClearable
                        />
                    </div>
                </div>

                <div className="flex justify-end">
                    <button onClick={handleReset} className="text-gray-500 text-xs p-1">
                        Limpiar filtros
                    </button>
                </div>
            </div>
        </FilterToggle>
    );
};

export default FilterQYR;